import { ExportResultCode } from '@opentelemetry/core';
import { ModuleFE_OpenTelemetry } from '../ModuleFE_OpenTelemetry.js';
export class FeToBeExporter {
    translateSpanToDTO = (span) => {
        span.resource.attributes;
        return {
            trace_id: span.spanContext().traceId,
            span_id: span.spanContext().spanId,
            parent_span_id: span.parentSpanContext?.spanId,
            name: span.name,
            kind: span.kind,
            startTime: span.startTime,
            endTime: span.endTime,
            attributes: span.attributes,
            events: span.events?.map((event) => ({
                time: event.time,
                name: event.name,
                attributes: event.attributes,
            })),
            links: span.links?.map((link) => ({
                trace_id: link.context.traceId,
                span_id: link.context.spanId,
                attributes: link.attributes,
            })),
            status: {
                code: span.status.code,
                message: span.status.message,
            }
        };
    };
    async export(spans, resultCallback) {
        // Send data to BE
        try {
            await ModuleFE_OpenTelemetry.v1.sendTelemetry({ spans: spans.map(this.translateSpanToDTO) }).executeSync(true);
            resultCallback({ code: ExportResultCode.SUCCESS });
            ModuleFE_OpenTelemetry.logInfoBold(`Succeeded sending spans: ${spans.map(span => span.name)}`);
        }
        catch (e) {
            resultCallback({ code: ExportResultCode.FAILED });
            ModuleFE_OpenTelemetry.logWarningBold(`Failed sending spans`);
        }
    }
    shutdown() {
        // Handle any cleanup before shutdown
        return Promise.resolve();
    }
}
//# sourceMappingURL=CustomExporter.js.map